export function formatNumeroUnidade(
  municipio: string | undefined | null,
  numeroUnidade: unknown,
): string {
  if (numeroUnidade === null || numeroUnidade === undefined || numeroUnidade === "") {
    return "";
  }

  const key = municipio?.toLowerCase();
  const valor = String(numeroUnidade);

  if (key === "mariana") {
    return valor.padStart(4, "0");
  }

  if (key === "maracanau" || key === "horizonte") {
    return valor.padStart(3, "0");
  }

  return valor;
}
